<template>
	<div class="min-vh-100 pb-5">
		<template v-if="event">
			<p v-if="event.client.contact_astreinte" class="mb-0" ><b>Contact d'astreinte : </b>{{ event.client.contact_astreinte }}</p>
			<p v-if="event.client.consignes" class="mb-0" ><b>Consignes particulières : </b>{{ event.client.consignes }}</p>
			<div class="d-flex mt-2">
				<input type="text" class="form-control mr-3" v-model="search" placeholder="Rechercher un véhicule">
				<a href="#" @click.prevent="search = ''" class="btn btn-rounded btn-outline-secondary mr-2"><i class="fa fa-times"></i></a>
				<a href="#" @click.prevent="createVehicle" class="btn btn-rounded btn-outline-secondary"><i class="fa fa-plus"></i></a>
			</div>

			<div v-for="(vehicles, type) in vehiclesByType" :key="`vehicles-`+type">
				<div class="font-size-h3 font-weight-bold mt-3">{{type}}</div>
				<a href="#" @click.prevent="clickVehicle(v)" class="d-flex justify-content-between border text-center py-1 px-2 mb-1" 
					:disabled="v.donttouch!==undefined&&v.donttouch===true"
					v-for="v in vehicles" :key="`vehicle-`+v.id" :class="getclassVehicle(v)">
					<div>
          				<i v-if="v.donttouch!==undefined&&v.donttouch==true" class="fa fa-ban text-muted"></i>
					</div>
					<div>
						{{v.name}} <span v-if="v.nserie">| {{v.nserie}}</span>
						<span class="font-size-xs text-dark font-weight-bold" v-if="v.site"> - {{v.site}}</span>
						<span v-if="getMotif(v)"> : {{getMotif(v)}}</span>
					</div>
					<div>
						 <span class="font-size-xs text-muted" v-if="v.lastlavage">{{formatLastLavage(v.lastlavage)}}</span>
					</div>

				</a>
			</div>

			<a href="#" v-if="!isAllVehiclesDone" class="btn btn-block btn-primary mt-3 mb-5 disabled">{{$t('Please fill all the vehicles')}}</a>
			<a href="#" v-else @click.prevent="recapitulatif" class="btn btn-block btn-primary mt-3 mb-5">{{$t('Go to summary')}}</a>
		</template>

	</div>
</template>


<script>
	
	// @ is an alias to /src
	import {mapActions, mapGetters} from 'vuex'
	
	export default {
		name: 'vehicles',
		props: ['eventid'],
		computed: {
			// mix the getters into computed with object spread operator
			...mapGetters('events', [
				'getEvent'
			]),
			...mapGetters('interventions', [
				'getIntervention'
			]),
			vehiclesByType(){
				let vehicles =  _.sortBy(this.event.parcs, 'name');

				if (this.search.length) {
					let terms = this.search.toLowerCase().replace('-', '').split(' ');
					
					return _.groupBy(_.filter(vehicles, (v)=> {
						return _.every(terms, (t) => 
							v.name.toLowerCase().replace('-', '').indexOf(t) > -1 || v.nserie.toLowerCase().replace('-', '').indexOf(t) > -1
						)
					}), 'type')
				}

				return _.groupBy(vehicles, 'type');
			},
			isAllVehiclesDone(){
				// finalement on laisse faire 
				return true; 
				// ne pas compter les véhicules dont on ne veut pas toucher
				let touchVehicleOnlys = _.filter(this.event.parcs, (vehicle)=> {
					return vehicle.donttouch === undefined || vehicle.donttouch !==true
				});

				// on compte uniquement les formulaires vraiment complété
				let parcsSaved = _.filter(this.intervention.parcs, (vehicle)=> {
					return vehicle.motif || 
						vehicle.motif_autre || 
						vehicle.cle || 
						vehicle.typelavage.length || 
						vehicle.end_at
				});

				return Object.keys(parcsSaved).length >= touchVehicleOnlys.length;
			}
		},
		beforeMount: function () {
			this.event = this.getEvent(this.eventid);
			this.intervention = this.getIntervention(this.eventid);
			this.setPageTitle(this.event.client.name);
		},
		data: function () {
			return {
				event: {},
				intervention: {},
				search : ''
			}
		},
        methods: {
			...mapActions('interventions', ['addVehicle']),
			...mapActions('config', ['setPageTitle']),
			formatLastLavage(date){
				if (!date) return '';
				return moment(date).fromNow();
			},
			createVehicle(){
				this.$router.push({name: 'VehicleForm', params: {eventid: this.event.uid}});
			},
			clickVehicle: async function (vehicle) {
				if (vehicle.donttouch!==undefined&&vehicle.donttouch===true){
					alert(this.$t('Ce véhicule n\'est pas à faire'));
					return;
				}
			    Dashmix.layout('header_loader_on');
			    await this.addVehicle({uid: this.eventid, vehicleid: vehicle.id});
                this.$router.push({name: 'vehicle', params: {eventid: this.event.uid, vehicleid: vehicle.id}});
			},
			recapitulatif(){
				if (Object.keys(this.intervention.parcs).length == 0) {
					alert(this.$t('Vous devez intervenir sur au moins un véhicule'));
					return;
				}
				this.$router.push({name: 'eventRecap', params: {eventid: this.event.uid}});
			},
			getclassVehicle(v){

				if (v.donttouch!==undefined&&v.donttouch==true) {
					return 'bg-gray text-muted ';
				}
				let response = this.intervention.parcs[v.id];
				if (!response) {
					// vehicule non vu pour le moment
					return '';
				}
				if (response.motif) {
					// vehicule qui n'a pas pu être lavé
					return 'border-danger text-danger';
				}
				if (response.end_at === '') {
					return 'border-warning text-warning';
				}
				return 'border-success text-success';
			},
			getMotif(v){
				let response = this.intervention.parcs[v.id];
				if (!response) {
					// vehicule non vu pour le moment
					return '';
				}
				if (response.motif) {
					// vehicule qui n'a pas pu être lavé
					return response.motif;
				}
				return '';
			}
        }
	}
</script>
